import React from 'react';
import Link from 'next/link';

import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  btnText?: string;
  linkclassName?: string;
  lang: 'en' | 'de';
};

export default function TermsAndCondition({
  className,
  linkclassName,
  btnText = 'weiter',
  lang,
}: Props) {
  return (
    <>
      {lang === 'en' ? (
        <p className={cn('mt-2 text-xs text-placeholder', className)}>
          By clicking &quot;{btnText}&quot; you agree to our{' '}
          <Link
            href={`/page/agb`}
            className={cn('text-primary hover:underline', linkclassName)}
          >
            Terms and Conditions
          </Link>
          {/* , Terms and Conditions for collecting points and{' '} */}, and{' '}
          <Link
            href={`/page/datenschutz`}
            className={cn('text-primary hover:underline', linkclassName)}
          >
            Privacy policy
          </Link>{' '}
        </p>
      ) : (
        <p className={cn('mt-2 text-xs text-placeholder', className)}>
          Beim klicken auf &quot;{btnText}&quot; stimmst du unseren{' '}
          <Link
            href={`/page/agb`}
            className={cn('text-primary hover:underline', linkclassName)}
          >
            AGB
          </Link>
          , Geschäftsbedingungen zur Sammlung von Punkten und{' '}
          <Link
            href={`/page/datenschutz`}
            className={cn('text-primary hover:underline', linkclassName)}
          >
            Datenschutzklärung
          </Link>{' '}
          zu.
        </p>
      )}
    </>
  );
}
